import { render, staticRenderFns } from "./modal-confirmacion-cuenta.vue?vue&type=template&id=dba2b9b6&scoped=true"
import script from "./modal-confirmacion-cuenta.vue?vue&type=script&lang=js"
export * from "./modal-confirmacion-cuenta.vue?vue&type=script&lang=js"
import style0 from "./modal-confirmacion-cuenta.vue?vue&type=style&index=0&id=dba2b9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba2b9b6",
  null
  
)

export default component.exports